import { node } from "prop-types";
import { useContext } from "react";

import styled from "styled-components/macro";
import { indented } from "theme";

import FnrTypography from "FnrTypography/FnrTypography";

import FnrFade from "UI/FnrFade/FnrFade";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import CenteredChevron from "./CenteredChevron";
import { FnrAccordionContext } from "./FnrAccordion";
import SizeMaintainerRelay from "./SizeMaintainerRelay";

const SFnrVerticalGap = styled(FnrVerticalGap)`
  ${indented}
`;

const Contents = ({ children }) => {
  const {
    active,
    alignContentToLabel,
    cardIsShowing,
    chevronStyle,
    dark,
    helperText,
  } = useContext(FnrAccordionContext);

  return (
    <>
      <SizeMaintainerRelay>
        <FnrFade show={active}>
          <FnrVerticalGap>
            {helperText && (
              <FnrTypography
                fontSize="sm"
                color={dark ? "textLight" : "textSecondary"}
                data-cy="FnrAccordion_HelperText"
                xMarginAdjust={8}
              >
                {helperText}
              </FnrTypography>
            )}
            <SFnrVerticalGap
              data-cy="FnrAccordion_ContentContainer"
              $noIndent={!alignContentToLabel || cardIsShowing}
            >
              {children}
            </SFnrVerticalGap>
          </FnrVerticalGap>
        </FnrFade>
      </SizeMaintainerRelay>
      {chevronStyle === "centered" && <CenteredChevron />}
    </>
  );
};

Contents.propTypes = { children: node };

export default Contents;
